var styleDataHash = "d1baa98b";
const injectCss = () => {
  var css = `.qNfiA{box-sizing:border-box;height:29px;max-width:100%;width:100%}[dir] .qNfiA{margin:0 auto;padding-top:14px}[dir] ._2KWlP{padding-top:11px}.v1e8-{display:block;stroke:currentColor;stroke-width:1;shape-rendering:crispEdges}.Vvv2-,.iVvC5,.sKCtm,.uHORr{height:100%}.Vvv2-{stroke-dasharray:4 4}.iVvC5{stroke-dasharray:1 5}.UbuK2{width:10%}._6R9bA{width:40%}.GNRLK{width:100%}[dir=ltr] ._3dUiD{margin-right:auto}[dir=rtl] ._3dUiD{margin-left:auto}[dir] .gLTIx{margin:0 auto}[dir=ltr] .bR0Ad{margin-left:auto}[dir=rtl] .bR0Ad{margin-right:auto}.Yd0Av{height:100%}.Yd0Av .Ncz5Y{height:1px}.i1c1x{align-items:center;display:flex;height:38px}[dir=ltr] .i1c1x{padding:0 30px 0 0!important}[dir=rtl] .i1c1x{padding:0 0 0 30px!important}.ZUSro{height:18px;max-width:60px;overflow:hidden;width:60px}[dir] .ZUSro{padding-top:7px}._3t5G-{stroke:currentColor!important}.ziHPV{width:100%}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var default_styles_default = {
  "divider-container": "qNfiA",
  "divider-container--double": "_2KWlP",
  "divider": "v1e8-",
  "divider--single": "sKCtm",
  "divider--double": "uHORr",
  "divider--dashed": "Vvv2-",
  "divider--dotted": "iVvC5",
  "divider--small": "UbuK2",
  "divider--medium": "_6R9bA",
  "divider--large": "GNRLK",
  "divider--left": "_3dUiD",
  "divider--center": "gLTIx",
  "divider--right": "bR0Ad",
  "svgFixerContainer": "Yd0Av",
  "emptyChar": "Ncz5Y",
  "divider-dropdown__control": "i1c1x",
  "divider-dropdown__option": "ZUSro",
  "divider-dropdown__divider": "_3t5G-",
  "divider_line_icon": "ziHPV"
};
export {
  default_styles_default as default,
  injectCss
};
//# sourceMappingURL=default-styles-scss.js.map
